import React, { useMemo } from "react";

import { isEmpty } from "lodash/fp";

import AnnotatedSpeech from "@app/analytics/MeetingReport/components/AnnotatedSpeech";
import { TranscriptTurnSpeechBubble } from "@app/analytics/MeetingReport/components/TranscriptTurn";
import useSearchStore from "@app/analytics/MeetingReport/stores/search";
import type { TranscriptSearchResult } from "@app/analytics/MeetingReport/types";
import { chunkParagraphContent } from "@app/analytics/MeetingReport/utils";
import type {
  ReactionHighlight,
  TranscriptTurnParagraph,
} from "@app/common/types";

interface ReadonlyTranscriptTurnItemContentProps {
  onClick?: () => void;
  paragraph: TranscriptTurnParagraph & { focused?: boolean };
  reactions: ReactionHighlight[];
}

const EMPTY_SEARCH_RESULTS: TranscriptSearchResult[] = [];

const ReadonlyTranscriptTurnItemContent = ({
  onClick,
  paragraph,
  reactions,
}: ReadonlyTranscriptTurnItemContentProps) => {
  const searchResults = useSearchStore(
    (state) =>
      state.searchResultsByParagraphId.get(paragraph.id) ?? EMPTY_SEARCH_RESULTS
  );

  const hasAnnotations = !isEmpty(reactions) || !isEmpty(searchResults);

  const chunkedContent = useMemo(() => {
    if (!hasAnnotations) return;
    return chunkParagraphContent(paragraph, reactions, searchResults);
  }, [reactions, searchResults]);

  return (
    <TranscriptTurnSpeechBubble
      text={paragraph.text}
      onClick={onClick}
      active={paragraph.focused}
    >
      {chunkedContent ? (
        <AnnotatedSpeech paragraphChunk={chunkedContent} />
      ) : (
        paragraph.text
      )}
    </TranscriptTurnSpeechBubble>
  );
};

export default ReadonlyTranscriptTurnItemContent;
